<script>
    import MegaSelect from '../MegaSelect/MegaSelect.svelte';
    import {sgettext} from '../../i18n.js';
    import { BRANCH_ASSIGNED_WORK_CENTRES_API } from '../../apiUrls.js';
    import {
        dashBoardWorkCentreId,
    } from './dashBoardStrore.js';
    import { homePageMWCSize } from './columnConstants';

    export let branchId;
    export let workCentreId;

    let workCentreOptions = [];
	const fetchWorkCentres = async (branchId) => {
        const wcResponse = await (await fetch(BRANCH_ASSIGNED_WORK_CENTRES_API.replace('{id}', branchId)+`?limit=${homePageMWCSize}`)).json();
        workCentreOptions = wcResponse.results.map(w => ({...w, description: w.description ? `${w.description} - ${w.plant}` : (w.plant ? w.plant : '')}));
    }

    $:fetchWorkCentres(branchId)

    let handleSelectWorkCentre = event => {
        dashBoardWorkCentreId.set(event.detail.id);
    }

    let handleClearWorkCentre = event => {
        dashBoardWorkCentreId.set(0);
    }

</script>

<div class="search-title">
    {sgettext("$$MAIN_WORK_CENTRE$$")}
</div>

<div class="search-theme">
    <MegaSelect
        id="work-centre-select"
        options={workCentreOptions}
        placeholder=""
        noOptionsMessage={sgettext('$$RESULTS_FOUND$$')}
        itemValueKey="id"
        itemLabelKey="name"
        itemDescriptionKey="description"
        showDescriptions={true}
        centerItems={true}
        clearable={true}
        searchIcon={true}
        showImages={false}
        onSelectItem={handleSelectWorkCentre}
        onClear={handleClearWorkCentre}
        selectHeight=40
        unselectedHeight=40
        bind:selectedItem={workCentreId}
    />
</div>

<style>
	.search-theme {
		--borderRadius: 15px;
        width: 200px;
        padding-right: 10px;
        padding-bottom: 10px;
	}
    .search-title {
        padding-right: 20px;
        padding-top: 7.5px;
	}
</style>
